import { JSX, PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

export interface GradientBorderProps extends PropsWithChildren {
    className?: string;
}

/**
 * Increase the padding to increase the border width.
 */
export const GradientBorder = ({ className, children }: GradientBorderProps): JSX.Element => {
    return (
        <div
            data-testid="gradient-border"
            className={twMerge(
                'rounded-xl p-0.5 bg-gradient bg-linear-to-bl from-bubblegum-400 via-60% via-ocean-300 to-70% to-yellow-400',
                className,
            )}
        >
            {children}
        </div>
    );
};
